import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { NgIf } from '@angular/common';
import { FeathericonsModule } from '../icons/feathericons/feathericons.module';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/api-services/user.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-landing-access',
  standalone: true,
  imports: [MatButtonModule, MatInputModule, ReactiveFormsModule, MatFormFieldModule, MatCardModule, NgIf,
    FeathericonsModule, RouterModule, MatProgressSpinnerModule],
  templateUrl: './landing-access.component.html',
  styleUrl: './landing-access.component.scss'
})

export class LandingAccessComponent implements OnInit {

  accessForm: FormGroup = new FormGroup({});
  btnDisabled = true;
  accessToken = '';
  incorrectCredentialsText = '';
  showWarning = false;

  isLoading = false;
  isVerifying = true;
  hidePassword = true;

  errorMessage = '';
  showMessage = false;

  constructor(private router: Router, private fb: FormBuilder, private apiService: UserService,
    private authService: AuthService, private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.accessForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
    this.verify();
    this.errorMessage = '';
    this.showMessage = false;
    this.showWarning = false;
    this.incorrectCredentialsText = '';
  }

  private verifyResponse(response: any) {
    if (Object.keys(response).includes('message')) {
      if (response.message === 'Incorrect credentials') {
        this.errorMessage = 'The credentials are incorrect. Please try again.';
        this.showMessage = true;
        return;
      }

      if (response.message === 'Access granted') {
        // Successful login
        this.authService.login(); // Update authentication state
        const redirectUrl = sessionStorage.getItem('redirectUrl') || '/main';
        sessionStorage.removeItem('redirectUrl');
        this.router.navigate([redirectUrl]); // Redirect to the intended page
      }
    }
  }


  verify() {
    this.isLoading = true;
    this.changeDetector.detectChanges();

    this.apiService.verifyUser().subscribe({
      next: response => {
        if (!environment.production) {
          console.log(response);
        }
        if (response.message.includes('Valid')) {
          this.authService.login();
          const redirectUrl = sessionStorage.getItem('redirectUrl') || '/main';
          sessionStorage.removeItem('redirectUrl');
          this.router.navigate([redirectUrl]);
          // Navigation is underway — keep isVerifying true so the form never flashes
        } else {
          // Session is invalid/expired — reveal the login form
          this.isVerifying = false;
        }
      },
      error: error => {
        if (!environment.production) {
          console.log(error);
        }
        // User is not authenticated — reveal the login form
        this.isVerifying = false;
        window.alert('Something went wrong when connecting to the server. Please contact admin.');
        this.isLoading = false;
        this.changeDetector.detectChanges();
      },
      complete: () => {
        this.isLoading = false;
        this.changeDetector.detectChanges();
      }
    })
  }

  signIn() {
    this.isLoading = true;
    this.changeDetector.detectChanges();

    // this.verifyLoggedInUser(false);
    if (this.accessForm.get('email') !== null && this.accessForm.get('password') !== null) {
      const email = this.accessForm.get('email')?.value;
      const password = this.accessForm.get('password')?.value;

      if (this.isEmail(email)) {
        this.apiService.signin('', email, password).subscribe({
          next: response => {
            this.verifyResponse(response);

          },
          error: error => {
            this.isLoading = false;
            this.changeDetector.detectChanges();

            if (error.error && error.error.message.startsWith('Incorrect')){
              this.errorMessage = 'The credentials are incorrect. Please try again.'
              this.showMessage = true;
              this.changeDetector.detectChanges();
            }
            if (!environment.production) {
              console.log(error);
            }
            this.accessForm.reset();
          },
          complete: () => {
            this.isLoading = false;
            this.changeDetector.detectChanges();
          }
        });
      }
    } else {
      this.errorMessage = 'Something went wrong while accessing login fields. Please try again.';
      this.showMessage = true;
    }

  }

  private isEmail(value: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(value);
  }
}
